import cloneDeep from "lodash-es/cloneDeep";

export const buildURLsFromHost = host => {
  // No host, return
  if (!host) {
    console.warn("No host set, can't build service urls");
    return null;
  }

  if (!window.document) {
    return {};
  }

  const parser = window.document.createElement("a");
  parser.href = host;

  const split = parser.host.split(".");
  split.shift();

  const prefix = parser.protocol + "//",
    apiDomain = ["visibility", ...split],
    privateDomain = ["private.intel", ...split],
    publicDomain = ["intel", ...split],
    orbitalDomain = ["orbital", ...split];

  return {
    apiHost: prefix + apiDomain.join("."),
    privateURL: prefix + privateDomain.join(".") + "/ctia",
    publicURL: prefix + publicDomain.join(".") + "/ctia",
    orbitalURL: prefix + orbitalDomain.join("."),
    sdkUrl: "https://securex-sdk.security.cisco.com"
  };
};

export const scrubId = id => {
  if (!id) {
    return;
  }
  const split = id.split("/");

  if (split.length > 1) {
    return split[split.length - 1];
  } else {
    return id;
  }
};

export const mapReqOptions = (data = {}) => {
  const clone = cloneDeep(data);

  clone.sort_order = data.sortOrder;
  clone.sort_by = data.sortBy;

  delete clone.sortOrder;
  delete clone.sortBy;

  return clone;
};

export const mapServiceURLs = hostConfig => {
  const {IROH_UI_CONFIG: hosts} = hostConfig,
    {
      "api-base-uri": apiHost,
      "private-ctia-url": privateURL,
      "default-ctia-url": publicURL,
      "orbital-url": orbitalURL,
      "orbital-urls": alternateOrbitalURL,
      "application-urls": applicationUrls = {},
      sdkUrl
    } = hosts,
    {orb} = applicationUrls;

  return {
    apiHost,
    privateURL,
    publicURL,
    orbitalURL: orb || orbitalURL || alternateOrbitalURL,
    sdkUrl
  };
};

export const decodeJWT = token => {
  if (!token) {
    return null;
  }

  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};
